/**
 *   Copyright (C) Cylergie - All Rights Reserved
 * Proprietary and confidential
 * Subject to French law on copyright
 * Unauthorized copying of this file, via any medium is strictly prohibited: https://crigen.myengie.com/copyright
 * Any request for authorization of use should be addressed by email to"mvalo.bvt@engie.com" with the subject "Copyright Statement in Source Code"
 * Written in 2024
 */

/* eslint-disable */

import { createRouter, createWebHistory } from 'vue-router';
import { navigationGuard } from '@okta/okta-vue';

// Import okta callback
import implicitCallback from '@/components/boilerplate/implicitCallback';

const PageNotFound = () => import('@/pages/NotFound.vue');

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // OKTA CALLBACK ROUTES
    {
      path: '/login/callback',
      component: implicitCallback,
    },
    {
      path: '/implicit/callback',
      component: implicitCallback,
    },
    // 404 ROUTE
    {
      path: '/404',
      name: 'NotFound',
      component: PageNotFound,
    },
    // MAIN ROUTE - requires authentication
    {
      path: '/',
      name: 'Wizard',
      component: () => import('../views/Wizard.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    // CATCH ALL - redirect to 404
    {
      path: '/:pathMatch(.*)*',
      name: 'AllPath',
      redirect: {
        path: '/404',
      },
    },
  ],
});

// OKTA Navigation Guard - redirects to Okta login if not authenticated
router.beforeEach(navigationGuard);

export default router;
